import { mapState, mapActions } from "vuex"

export default {
  computed: {
    ...mapState(["contracts", "web3"])
  },

  mounted() {
    this.$store.dispatch("checkWeb3")
  },

  methods: {
    ...mapActions(["requireWeb3", "addPlannedTx"])
  }
}
